module.exports = __webpack_public_path__ + "img/menu-bar.eb04a54f.svg";